// NPM
import React from 'react'

// Components
import Description from 'src/components/Shared/Description'

const OurMission = ({ section }) => {
  if(!section) {
    return null
  }

  return (
    <div className="OurMission">
      <div className="OurMission__content">
        <h4 className="OurMission__title small-header">
          { section.title }
        </h4>

        <Description
          className="OurMission__description"
          description={ section.description }
        />
      </div>
    </div>
  )
}

export default OurMission